import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { getSocket } from "../../services/socket";
import { useNavigation } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { RootStackParamList } from "../navigator";
import Toast from "react-native-toast-message";

type Nav = NativeStackNavigationProp<RootStackParamList>;

const NotificationsListener = () => {
  const auth = useSelector((s: RootState) => s.auth);
  const isLoggedIn = !!auth?.user;
  const playerId = auth?.user?.id || "";
  const username = auth?.user?.username || "";

  const navigation = useNavigation<Nav>();

  useEffect(() => {
    if (!isLoggedIn || !playerId || !username) return;

    const socket = getSocket(String(playerId), String(username));

    const handler = (packet: any) => {
      console.log("🔔 [socket] getNotifications", packet);

      if (packet?.success) {
        const notifications = packet.notifications || [];

        if (!Array.isArray(notifications) || notifications.length === 0) return;

        // case 1: single notification
        if (packet.data) {
          Toast.show({
            type: "success",
            text1: packet.data.title || "Notification",
            text2: packet.data.body || "",
            position: "bottom",
            visibilityTime: 3000,
            text1Style: { fontSize: 16 },
            text2Style: { fontSize: 14, color: "#100f14ff" },
          });
          return;
        }

        // case 2: list of notifications

        notifications.forEach((n) => {
          Toast.show({
            type: "success",
            text1: n.title || "Notification",
            text2: n.message || "",
            position: "bottom",
            visibilityTime: 3000,
            text1Style: { fontSize: 16 },
            text2Style: { fontSize: 14, color: "#100f14ff" },
          });
        });
      }
    };

    socket.on("getNotifications", handler);

    return () => {
      socket.off("getNotifications", handler);
    };
  }, [isLoggedIn, playerId, username]);

  return null;
};

export default NotificationsListener;
